import { render, staticRenderFns } from "./addGiftPackage.vue?vue&type=template&id=e83c34e8&scoped=true&"
import script from "./addGiftPackage.vue?vue&type=script&lang=js&"
export * from "./addGiftPackage.vue?vue&type=script&lang=js&"
import style0 from "./addGiftPackage.vue?vue&type=style&index=0&id=e83c34e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83c34e8",
  null
  
)

export default component.exports